import React from 'react';
import PropTypes from 'prop-types';

const RadioFilter = props => {
    const { name, options = [], selected, onChange, isPickleBallFilter, 'data-testid': dataTestId } = props;

    return (
        <div className={`row`}>
            {options.map((option, i) => {
                return (
                    <div key={`${name}${i}`} className={`col-12  ${isPickleBallFilter ? '' : null}`}>
                        <input
                            type="radio"
                            name={name}
                            id={`${name}${i}`}
                            value={`${option.label}`}
                            className={`standalone-radio ${isPickleBallFilter ? '' : 'standalone-radio'}`}
                            checked={selected === option.label}
                            onChange={(e) => onChange(e.target.value)}
                            data-testid={dataTestId && `${dataTestId}.radio-${i}`}
                        />
                        <label htmlFor={`${name}${i}`} data-testid={dataTestId && `${dataTestId}.label-${i}`}><span className={`${isPickleBallFilter ? '' : null}`} />{`${option.description === 'HighSchool' ? 'High School' : option.description}`}</label>
                    </div>
                );
            })}
        </div>
    );
};

RadioFilter.propTypes = {
    isPickleBallFilter: PropTypes.bool,
    name: PropTypes.string.isRequired,
    options: PropTypes.instanceOf(Array),
    selected: PropTypes.bool,
    onChange: PropTypes.func,
    'data-testid': PropTypes.string,
};

RadioFilter.defaultProps = {
    isPickleBallFilter: false,
    options: [],
    selected: false,
    onChange: () => { },
    'data-testid': undefined,
};

export default RadioFilter;
